import { useEffect, useRef, useState } from "react";
import "./ScrollAnimation.css";

const ScrollAnimation = ({
    className = "",
    children,
    type = "fade",
    delay = 0,
    duration = 1000,
    threshold = 0.1,
    easing = "ease-in-out",
    ...restProps
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: threshold,
                rootMargin: "0px 0px -50px 0px",
            }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => observer.disconnect();
    }, [threshold]);

    // Check if this is a reveal animation that needs content wrapper
    const isRevealAnimation = type.startsWith("reveal");
    if (isRevealAnimation) {
        type = `reveal ${type}`;
    }

    return (
        <div
            ref={elementRef}
            className={`${className} scroll-animation ${type} ${isVisible ? "animate" : ""}`}
            style={{
                "--animation-delay": `${delay}ms`,
                "--animation-duration": `${duration}ms`,
                "--animation-easing": easing,
            }}
            {...restProps}
        >
            {isRevealAnimation ? (
                <div className="scroll-animation-content">{children}</div>
            ) : (
                children
            )}
        </div>
    );
};

export default ScrollAnimation;
